var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "sys-teacher-hub-modal",
    {
      attrs: {
        show: _vm.show,
        title: _vm.title,
        icon: _vm.icon,
        "max-width": "820",
      },
      on: {
        "update:show": function ($event) {
          return _vm.$emit("update:show", $event)
        },
      },
    },
    [
      _c(
        "v-card-text",
        { staticClass: "pa-0" },
        [
          _c("sys-teacher-work-load-confirm", {
            attrs: {
              teacher: _vm.teacher,
              "work-time": _vm.workTime,
              token: _vm.token,
              "allow-actions": true,
            },
            on: { onComplete: _vm.handleComplete },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }